module.exports = __webpack_public_path__ + "img/palmas-pool-2.d3825dbd.jpg";